import React, { useState } from 'react';
import { action, makeObservable } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import { AutomaticWithdrawalState } from 'src/AppState/AutomaticWithdrawalState';
import { Switcher } from 'src/components/SwitcherNew/Switcher';
import { SwitcherWrapper } from 'src/components/FraudAndCompliance/AutomaticWithdrawals/AutomaticWithdrawals.style';
import { FormInputState } from 'src_common/common/mobx-utils/Form2/FormInputState';

class State {
    public readonly isAutomaticWithdrawal: FormInputState<boolean, boolean>;
    private readonly automaticWithdrawalState: AutomaticWithdrawalState;

    public constructor(automaticWithdrawalState: AutomaticWithdrawalState, value: () => boolean) {
        this.automaticWithdrawalState = automaticWithdrawalState;
        this.isAutomaticWithdrawal = FormInputState.new(value());
        makeObservable(this);
    }

    @action public onSwitchAutomaticWithdrawal = async (): Promise<void> => {
        const switcherVatlue = this.isAutomaticWithdrawal.value;
        await this.automaticWithdrawalState.onSwitchAutomaticWithdrawal(switcherVatlue);
    };
}

interface PropsType {
    value: boolean;
}

export const SwitcherSet = observer(({ value }: PropsType) => {
    const { automaticWithdrawalState } = useAppStateContext();

    const [state] = useState(() => new State(automaticWithdrawalState, () => value));

    return (
        <SwitcherWrapper>
            <Switcher
                state={state.isAutomaticWithdrawal}
                label='Automatic Withdrawals'
                onChange={state.onSwitchAutomaticWithdrawal}
                marginBottom='24px'
            />
        </SwitcherWrapper>
    );
});
